<template>
  <div>
    <page-title
      :heading="`${isTambah ? 'Tambah' : 'Ubah'} Bahan Habis Pakai`"
      :breadcrumb="[
        {
          label: 'Manajemen Obat & BHP',
          link: '/manajemen-obat-bhp'
        },
        {
          label: `${isTambah ? 'Tambah' : 'Ubah'} Obat & BHP`,
          active: true
        }
      ]"
      class="layout-gantung ninja-shadow custom-breadcrumb"
    />
    <div class="container-fluid __zoom_display page-add-bhp">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body p-5">
          <!-- FORM -->
          <div class="row">
            <div class="col-12 col-sm-11 mb-4">
              <div class="row" v-if="satusehatAuthValid">
                <div class="col-12 col-sm-6 pl-0">
                  <div class="outer-bhp">
                    Apabila tidak mengisi KFA, maka data tidak akan sync ke
                    SatuSehat
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-row v-for="(bhp, index) in $v.bhpList.$each.$iter" :key="index">
            <b-col sm="11 outer-bhp" :class="{ 'mt-5': index > 0 }">
              <b-row>
                <b-col sm="6">
                  <!-- kode bhp -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >Kode BHP <span style="color:red">*</span></label
                      >
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        id="inline-form-input-kode"
                        placeholder="input kode BHP"
                        :value="bhpList[index].kode_layanan"
                        :class="{
                          'is-invalid': bhp.kode_layanan.$error
                        }"
                        @input="setKodeBhp(index, $event)"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ setErrorMessage("Kode BHP", bhp.kode_layanan) }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- Kode KFA -->
                  <div class="row pb-3" v-if="satusehatAuthValid">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >Kode KFA</label
                      >
                    </div>
                    <div class="col-md-7">
                      <vue-select
                        style="font-size:13px"
                        :options="optObatKfa"
                        @input="inputBhpKfa($event, index)"
                        v-model="bhpList[index].bhp_kfa"
                        class="form-select-tarif"
                        placeholder="Tulis kode KFA"
                        @search="debounceSearchBhp"
                        :isClearable="true"
                        :keyOpt="'kode_kfa'"
                      />
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                    <div class="col-md-2">
                      <b-button
                        @click="copyDataKfa(index)"
                        variant="primary"
                        :disabled="!bhpList[index].bhp_kfa"
                        class="w-100 px-2"
                        style="font-size:12px"
                      >
                        <font-awesome-icon icon="clone" />
                        Copy
                      </b-button>
                    </div>
                  </div>

                  <!-- nama bhp -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >Nama BHP <span style="color:red">*</span></label
                      >
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        placeholder="input nama BHP"
                        :class="{
                          'is-invalid': bhp.nama_layanan.$error
                        }"
                        :value="bhpList[index].nama_layanan"
                        @input="setNamaBhp(index, $event)"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        {{ setErrorMessage("Nama BHP", bhp.nama_layanan) }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- satuan -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;">
                        Satuan</label
                      >
                    </div>
                    <div class="col-md-9">
                      <vue-select
                        style="font-size:13px"
                        :options="optSatuan"
                        v-model="bhpList[index].satuan_id"
                        class="form-select-tarif"
                        placeholder="pilih satuan"
                        :disabled="!stockIsEdit && isEdit"
                      />
                      <b-form-invalid-feedback></b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- BHP BPJS -->
                  <div class="row pb-3">
                    <div class="col-12 col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >BHP BPJS</label
                      >
                    </div>
                    <div class="col-12 col-md-9">
                      <vue-select
                        style="font-size:13px"
                        :options="optObatBpjs"
                        v-model="bhpList[index].is_bpjs"
                        class="form-select-tarif"
                        placeholder="pilih BHP BPJS"
                        :isClearable="true"
                      />
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- Manufactur -->
                  <div class="row pb-3" v-if="bhpList[index].bhp_kfa">
                    <div class="col-md-3">
                      <label style="font-size: 13px;padding:5px;"
                        >Manufactur
                      </label>
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        disabled
                        :value="bhpList[index].manufactur"
                      ></b-form-input>
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- Bentuk Sediaan -->
                  <!-- <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size: 13px;padding:5px;"
                        >Bentuk Sediaan
                      </label>
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        disabled
                        :value="bhpList[index].bentuk_sediaan"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                      </b-form-invalid-feedback>
                    </div>
                  </div> -->
                </b-col>
                <b-col sm="6">
                  <!-- BHP BPJS -->
                  <!-- <div class="row pb-3" v-if="bhpList[index].bhp_kfa">
                    <div class="col-12 col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >BHP BPJS</label
                      >
                    </div>
                    <div class="col-md-9">
                      <vue-select
                        style="font-size:13px"
                        :options="optObatBpjs"
                        v-model="bhpList[index].is_bpjs"
                        class="form-select-tarif"
                        placeholder="pilih BHP BPJS"
                        :isClearable="true"
                      />
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                  </div> -->

                  <!-- stok -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;">Stok BHP</label>
                    </div>
                    <div class="col-md-9 d-flex align-items-center">
                      <b-form-input
                        v-model="bhpList[index].stok"
                        @change="
                          onChangeValue({
                            label: 'stok',
                            index,
                            $event
                          })
                        "
                        style="padding-right : 30px"
                        v-on:keypress="NumbersOnly"
                        maxlength="100"
                        placeholder="input stok"
                        :disabled="!stockIsEdit && isEdit"
                      ></b-form-input>
                      <span
                        v-if="!stockIsEdit && isEdit"
                        @click="enableEdit()"
                        style="padding-left: 10px; cursor: pointer;"
                      >
                        <font-awesome-icon icon="pencil-alt" />
                      </span>
                      <b-form-invalid-feedback></b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- HET -->
                  <div class="row pb-3" v-if="bhpList[index].bhp_kfa">
                    <div class="col-md-3">
                      <label style="font-size: 13px;padding:5px;">HET </label>
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        disabled
                        :value="bhpList[index].het"
                      ></b-form-input>
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- Harga Beli -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >Harga Beli</label
                      >
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        v-on:keypress="NumbersOnly"
                        :value="format_money(bhpList[index].harga_beli)"
                        @input="onInputHargaBeli($event, index)"
                        maxlength="19"
                      ></b-form-input>
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- Margin -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;">Margin</label>
                    </div>
                    <div class="col-md-9">
                      <b-form-input
                        :value="format_money(bhpList[index].margin)"
                        maxlength="19"
                        disabled
                      ></b-form-input>
                      <b-form-invalid-feedback> </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- Harga Jual -->
                  <div class="row pb-3">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >Harga Jual <span style="color:red">*</span></label
                      >
                    </div>
                    <div class="col-md-9">
                      <money
                        id="inline-form-input-tarif"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            setErrorMessage('Harga Jual', bhp.tarif.$model) !==
                            ''
                        }"
                        v-model="bhp.tarif.$model"
                        v-bind="money"
                        @input="parseHarga(index, bhp.tarif.$model)"
                      ></money>
                      <b-form-invalid-feedback>
                        {{ setErrorMessage("Harga Jual", bhp.tarif.$model) }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- catatan -->
                  <div class="row pb-3" style="align-items:top;">
                    <div class="col-md-3">
                      <label style="font-size:13px; padding:5px;"
                        >Catatan</label
                      >
                    </div>
                    <div class="col-md-9">
                      <b-form-textarea
                        :disabled="!stockIsEdit && isEdit"
                        rows="4"
                        no-resize
                        v-model="bhpList[index].note"
                        @change="
                          onChangeValue({
                            label: 'note',
                            index,
                            $event
                          })
                        "
                        placeholder="input catatan pendukung.
Contoh: Masa berlaku bhp
20 September 2025, pembelian batch 1."
                      ></b-form-textarea>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <!-- action minus -->
            <b-col sm="1" style="margin-top:125px;">
              <div align="right">
                <b-button
                  variant="danger"
                  v-if="isTambah && index > 0"
                  :style="btnRemoveMobileStyle"
                  @click="removeBhp(index)"
                >
                  <font-awesome-icon icon="minus" class="fa-sm" />
                </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- END FORM -->
          <b-row class="d-flex align-items-center ">
            <b-col lg="11 p-0">
              <div class="d-flex justify-content-center mt-4">
                <b-button
                  v-if="isTambah"
                  style="padding: .4rem .7rem; background: #42abdc; color: white; border: 2px solid #42abdc;  border-radius: 100%"
                  @click="addBhp"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>
              </div>
              <div align="right">
                <b-button
                  class="text-capitalize mr-2"
                  variant="danger"
                  :to="{ name: 'klinik-list-bhp' }"
                  >Keluar</b-button
                >
                <b-button
                  class="text-capitalize"
                  variant="primary"
                  @click="saveBhp()"
                  >Simpan</b-button
                >
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { Money } from "v-money";
import debounce from "lodash/debounce";

import {
  faCopy,
  faDownload,
  faUpload,
  faPlus,
  faMinus,
  faPencilAlt,
  faClone
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCopy,
  faUpload,
  faDownload,
  faPlus,
  faMinus,
  faPencilAlt,
  faClone
);

// custom validation
const charVal = value => {
  const regex = new RegExp("^([0-9a-zA-Z-]*)$");
  return regex.test(value);
};

const duplicate = function(value, bhp) {
  const bhpList = this.$v.bhpList.$model,
    bhpTotal = bhpList.length,
    key = Object.keys(bhp).find(key => bhp[key] === value);

  if (bhpTotal <= 1) return true;

  const bhpIndex = this.bhpList.findIndex(bhp => bhp[key] === value);

  const isDuplicate = [...bhpList]
    .splice(bhpIndex + 1, bhpTotal - 1)
    .some(val => {
      return value == val[key];
    });

  return !isDuplicate;
};

const duplicateBe = async function(value, bhp) {
  let key = Object.keys(bhp).find(key => bhp[key] === value);
  if (value == "" || value == null) return true;
  if (
    this.isEdit &&
    value == (key == "kode_layanan" ? this.prevKodeBhp : this.prevNamaBhp)
  )
    return true;
  let response = await this.$axios.get(
    `klinik/bhp/cek?id=${this.bhp_id}&klinik_id=${this.getKlinikId}&kategori_id=3&${key}=${value}`
  );
  return response.data.status;
};

// Custom validation for harga jual not less than harga beli
const tarifNotLessThanHargaBeli = function(value) {
  // This function is called within the vuelidate context for each element
  // We need to access the corresponding harga_beli value from the same object
  // Since we're in the context of the tarif validation, we need to access the parent object
  // which is available as 'this' in the validation context

  // Get index from the context
  const index = this.$v.bhpList.$each.$iter.findIndex(
    bhp => bhp.tarif.$model === value
  );
  if (index !== -1) {
    // Access the corresponding harga_beli value from the actual data
    const correspondingHargaBeli = this.bhpList[index].harga_beli || 0;
    return value >= correspondingHargaBeli;
  }
  return true;
};

export default {
  name: "listBhp",
  components: {
    Money,
    "vue-select": () => import("@/components/VueSelect.vue")
  },
  data() {
    return {
      bhp_id: null,
      bhpCount: 2,
      bhpList: [
        {
          klinik_id: this.$store.getters.getKlinikId,
          kode_layanan: null,
          kategori_id: 3,
          nama_layanan: null,
          tarif: 0,
          harga_beli: 0,
          margin: 0,
          stok: null,
          satuan_id: null,
          note: null,
          is_bpjs: null,
          bhp_kfa: null,
          kfa_product_id: null,
          bentuk_sediaan: null,
          manufactur: null,
          het: "-"
        }
      ],
      beingSubmit: false,
      prevKodeBhp: "",
      prevNamaBhp: "",
      optSatuan: [],
      optObatKfa: [],
      optObatBpjs: ["Ya", "Tidak"],
      validationErrors: [], // Track custom validation errors

      // v-money
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "Rp",
        suffix: "",
        precision: 0
      },
      stockIsEdit: false
    };
  },
  validations: {
    bhpList: {
      $each: {
        kode_layanan: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(10),
          charVal,
          duplicate,
          duplicateBe
        },
        kategori_id: {},
        nama_layanan: {
          required,
          maxLength: maxLength(100),
          duplicate,
          duplicateBe
        },
        tarif: {}
      }
    }
  },
  computed: {
    btnRemoveMobileStyle() {
      if (this.isMobile()) {
        return {
          padding: ".4rem .7rem",
          "border-radius": "100%",
          "margin-left": "-22px"
        };
      }

      return {
        padding: ".5rem .8rem",
        "border-radius": "100%",
        "margin-left": "-8px"
      };
    },
    ...mapGetters(["getKlinikId", "satusehatAuthValid"]),
    isTambah() {
      return this.bhp_id ? false : true;
    },
    isEdit() {
      return !this.isTambah;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: "Keluar",
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya"
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  created() {
    this.bhp_id = this.$router.currentRoute.params.id || "";
    this.getSatuan();

    if (this.isEdit) {
      this.$axios
        .get(`klinik/bhp/${this.bhp_id}?klinik_id=${this.getKlinikId}`)
        .then(res => {
          let { status, data } = res.data;
          let {
            klinik_id,
            nama_layanan,
            kode_layanan,
            kategori_id,
            tarif,
            harga_beli,
            margin,
            is_bpjs,
            stok,
            satuan,
            note,
            kfa
          } = data.bhp;

          let selectedSatuan = {};

          if (satuan != null) {
            selectedSatuan = {
              label: satuan.name,
              value: satuan.id
            };
          }

          if (status) {
            this.bhpList[0].tarif = tarif;
            this.bhpList[0].harga_beli = harga_beli || 0;
            this.bhpList[0].margin = margin || 0;
            this.bhpList[0].is_bpjs = is_bpjs === 1 ? "Ya" : is_bpjs === 0 ? "Tidak" : null; // Convert integer to string value
            this.bhpList[0].klinik_id = klinik_id;
            this.bhpList[0].kode_layanan = this.prevKodeBhp = kode_layanan;
            this.bhpList[0].nama_layanan = this.prevNamaBhp = nama_layanan;
            this.bhpList[0].kategori_id = kategori_id;
            this.bhpList[0].stok = stok == null ? "-" : stok;
            this.bhpList[0].satuan_id = selectedSatuan;
            this.bhpList[0].note = note;

            if (kfa) {
              // await this.getBhpKfa(kfa.kfa_code);
              this.bhpList[0].bhp_kfa = {
                ...kfa,
                label: `${kfa.kfa_code}-${kfa.name}`,
                value: kfa.id
              };
              this.bhpList[0].kfa_product_id = kfa.id;
              this.bhpList[0].manufactur = kfa.manufacturer;
              this.bhpList[0].het = kfa.het || "-";
            }
            // this.setKodeBhp(0, );
            return tarif;
          }
        });
    }
  },
  methods: {
    setKodeBhp: debounce(function(index, value) {
      this.bhpList[index].kode_layanan = value;
      this.$v.bhpList.$each[index].kode_layanan.$touch();
    }, 500),
    setNamaBhp: debounce(function(index, value) {
      this.bhpList[index].nama_layanan = value;
      this.$v.bhpList.$each[index].nama_layanan.$touch();
    }, 500),
    parseHarga(index, val = "Rp 0") {
      val = typeof val == "number" ? val.toString() : val;
      let rawHarga = val.indexOf(" ") >= 0 ? val.split(" ")[1] : val,
        harga = rawHarga.replace(/[,]+/g, "");
      this.bhpList[index].tarif = parseFloat(harga);

      // Calculate margin after harga jual changes
      if (this.bhpList[index].tarif < this.bhpList[index].harga_beli) {
        this.bhpList[index].margin = 0;
      } else {
        this.bhpList[index].margin =
          this.bhpList[index].tarif - this.bhpList[index].harga_beli;
      }

      // Trigger validation for this specific field
      this.$v.bhpList.$each[index].tarif.$touch();
    },
    parseMoney(value) {
      if (!value) return 0;
      // Hilangkan format "Rp. " dan tanda koma
      return parseFloat(value.replace(/[^\d]/g, "")) || 0;
    },
    onInputHargaBeli(event, index) {
      // get only digits
      const numeric = this.parseMoney(event);

      // update data
      this.bhpList[index].harga_beli = numeric;

      if (this.bhpList[index].tarif < this.bhpList[index].harga_beli) {
        this.bhpList[index].margin = 0;
      } else {
        this.bhpList[index].margin =
          this.bhpList[index].tarif - this.bhpList[index].harga_beli;
      }

      // Trigger validation for the corresponding tarif field
      this.$v.bhpList.$each[index].tarif.$touch();
    },
    onChangeValue({ index, label, $event }) {
      this.bhpList[index][label] = $event;
    },
    getErrorMessage(label, type, event) {
      const message = {
        required: `${label} harus di isi.`,
        minLength: `${label} minimal ${event[type] &&
          event[type].min} karakter.`,
        maxLength: `${label} Maksimal ${event[type] &&
          event[type].max} karakter.`,
        charVal: `Hanya bisa huruf, angka dan -`,
        duplicate: `${label} tidak boleh sama.`,
        duplicateBe: `${label} tidak boleh sama.`
      };

      return message[type];
    },
    setErrorMessage(label, event, message = "") {
      const validation =
        typeof event === "object" ? Object.keys(event.$params) : event;

      if (Array.isArray(validation)) {
        validation.every(type => {
          if (!event[type]) {
            message = this.getErrorMessage(label, type, event.$params);
            return false;
          }

          return true;
        });
      } else {
        // If it's not an array, handle directly
        if (typeof event === "object") {
          for (let type in event) {
            if (typeof event[type] === "object" && !event[type]) {
              message = this.getErrorMessage(label, type, event.$params);
              break;
            }
          }
        }
      }

      // Additional validation for Harga Jual not less than Harga Beli
      if (label === "Harga Jual") {
        // Find the index of the current bhp in the list
        const index = this.bhpList.findIndex(bhp => bhp.tarif === event);

        if (index !== -1) {
          const currentHargaBeli = this.bhpList[index].harga_beli || 0;
          // console.log(event, currentHargaBeli);
          if (event < currentHargaBeli) {
            message = "Harga Jual tidak boleh kurang dari Harga Beli";
          }
        }
      }
      // console.log(message);

      return message;
    },
    addBhp() {
      this.$v.$touch();
      this.bhpList.push({
        klinik_id: this.getKlinikId,
        kode_layanan: null,
        kategori_id: 3,
        nama_layanan: null,
        tarif: 0,
        harga_beli: 0,
        margin: 0,
        stok: null,
        satuan_id: null,
        note: null,
        is_bpjs: null,
        bhp_kfa: null,
        kfa_product_id: null,
        bentuk_sediaan: null,
        manufactur: null,
        het: "-"
      });
    },
    removeBhp(index) {
      this.bhpList.splice(index, 1);
    },
    triggerValidation() {
      return new Promise(resolve => {
        this.$watch(
          () => !this.$v.$pending,
          isNotPending => {
            if (isNotPending) {
              resolve(!this.$v.$invalid);
            }
          },
          { immediate: true }
        );
      });
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {}
    },
    async getBhpKfa(val) {
      if (val === "") return;

      try {
        const res = await this.$axios.get(
          `kfa/get-alat-kesehatan?limit=25&value=${val}`
        );

        const { data, status } = res.data;

        if (status) {
          this.optObatKfa = data.map(res => ({
            ...res,
            label: `${res.kfa_code}-${res.name}`,
            value: res.id
          }));
        }
      } catch (err) {
        console.log(err);
      }
    },
    debounceSearchBhp: debounce(function(val) {
      this.getBhpKfa(val);
    }, 500),
    inputBhpKfa(data, index) {
      const item = this.bhpList[index];

      if (!item.bhp_kfa) {
        item.kfa_product_id = null;
        item.bentuk_sediaan = null;
        item.manufactur = null;
        item.het = "-";
        return;
      }

      const bhp = item.bhp_kfa;

      item.kfa_product_id = bhp.value;
      item.bentuk_sediaan = bhp.satuan;
      item.manufactur = bhp.manufacturer;
      item.het = bhp.het_price ? this.format_money(bhp.het_price) : '-';
    },
    copyDataKfa(index) {
      const item = this.bhpList[index];
      if (item.bhp_kfa) {
        item.nama_layanan = item.bhp_kfa.name;
      } else {
        item.nama_layanan = "";
      }
    },
    format_money(value) {
      const { prefix, precision } = this.money;
      const formatter = new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      });

      return `${prefix}${formatter.format(value)}`;
    },
    async saveBhp() {
      if (
        this.isTambah ||
        (this.isEdit && this.bhpList[0].kode_layanan !== this.prevKodeBhp) ||
        (this.isEdit && this.bhpList[0].nama_layanan !== this.prevNamaBhp)
      )
        this.$v.$touch();
      await this.triggerValidation();
      this.beingSubmit = true;

      // Check if harga jual is less than harga beli for any item
      for (let i = 0; i < this.bhpList.length; i++) {
        if (this.bhpList[i].tarif < this.bhpList[i].harga_beli) {
          this.$swal({
            type: "warning",
            text: `Harga Jual pada BHP ke-${i +
              1} tidak boleh kurang dari Harga Beli!`
          });
          this.beingSubmit = false;
          return;
        }
      }

      try {
        if (!this.$v.bhpList.$error) {
          let response = this.isTambah
            ? await this.$axios.post(`klinik/bhp`, {
                arr: this.bhpList.map(v => {
                  const {
                    bhp_kfa,
                    bentuk_sediaan,
                    manufactur,
                    het,
                    ...cleanedV
                  } = v;
                  return {
                    ...cleanedV,
                    stok: parseInt(v.stok),
                    satuan_id: v.satuan_id != null ? v.satuan_id.value : "",
                    kfa_product_id: v.kfa_product_id,
                    harga_beli: parseInt(v.harga_beli),
                    margin: parseInt(v.margin),
                    is_bpjs: v.is_bpjs === "Ya" ? 1 : v.is_bpjs === "Tidak" ? 0 : null
                  }; // Convert string to integer
                }),
                klinik_id: this.getKlinikId
              })
            : await this.$axios.put(
                `klinik/bhp/${this.bhp_id}`,
                (() => {
                  const {
                    bhp_kfa,
                    manufactur,
                    het,
                    ...cleanedBhp
                  } = this.bhpList[0];
                  return {
                    ...cleanedBhp,
                    stok: parseInt(this.bhpList[0].stok),
                    satuan_id: this.bhpList[0].satuan_id.value,
                    kfa_product_id: this.bhpList[0].kfa_product_id,
                    harga_beli: parseInt(this.bhpList[0].harga_beli),
                    margin: parseInt(this.bhpList[0].margin),
                    is_bpjs: this.bhpList[0].is_bpjs === "Ya" ? 1 : this.bhpList[0].is_bpjs === "Tidak" ? 0 : null
                  }; // Convert string to integer
                })()
              );
          if (response.data.status) {
            this.$swal({
              title: `Data Berhasil disimpan`,
              type: "success"
            });
            this.$router.push({
              name: "klinik-list-bhp"
            });
          } else {
            throw response.data.message;
          }
        } else {
          let requiredText = document.getElementsByClassName("text-danger");
          if (requiredText.length > 0) {
            for (const required of requiredText) {
              required.previousSibling.focus();
              throw "Silakan cek kembali pengisian data Anda!";
            }
          }
          throw "Silakan cek kembali pengisian data Anda!";
        }
      } catch (error) {
        this.beingSubmit = false;
        this.$swal({
          type: "warning",
          text: `${error}`
        });
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57)) ||
        charCode === 46
      ) {
        evt.preventDefault();
      } else {
        if (this.isEdit) {
          this.bhpList[0].stok = this.bhpList[0].stok.replace(/-/g, "");
        }
        return true;
      }
    },
    enableEdit() {
      this.$swal({
        title: "Ubah Stok",
        html: `Apakah Anda yakin akan mengubah stok? <br/> Perubahan stok akan mempengaruhi pelaporan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya"
      }).then(res => {
        if (res.value) {
          this.stockIsEdit = true;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}

.form-select-tarif
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
}

.page-add-bhp {
  .vs__dropdown-option {
    white-space: wrap;
  }
  .vs--single .vs__selected {
    width: 90%;
  }

  .vs__selected-options {
    width: 80%;
  }

  .vs__selected-options .vs__selected {
    width: 87%;
  }

  .no-overflow {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .form-control {
    font-size: 13px;
    padding-left: 10px;
  }
}
</style>

<style lang="css" scoped>
.required:after {
  content: " *";
  color: red;
  padding-left: 5px;
}

.layout-gantung {
  border-radius: 0px 0px 10px 10px;
  max-height: 250px;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}
.__zoom_display {
  zoom: 80%;
}

/* #inline-form-input-kode,
#inline-form-input-tarif {
  width: 70%;
} */

.outer-bhp {
  position: relative;
  border-radius: 15px;
  border: 2px solid #bfbfbf;
  outline-color: #bfbfbf;
  padding: 15px;
  outline-width: thin;
}

.form-inline label {
  display: -moz-box;
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: flex-start;
  margin-bottom: 0;
}

.invalid-feedback {
  /* margin-left: 150px !important; */
  color: #f83245 !important;
}

@media screen and (max-width: 767px) {
  #inline-form-input-kode,
  #inline-form-input-tarif {
    width: 100%;
  }
}
</style>
